var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts_common"},[_c('div',{ref:"chartsBox",staticClass:"charts_box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }